import { Fragment } from "react";
import { Card, CardBody, Col } from "reactstrap";
import DropdownCommon from "../Common/DropdownCommon";
import TextLeftDemo from "./TextLeftDemo";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { JustifyContentTitle } from "../../../../Constants/Constants";
import { JustifyContentSubTitle, JustifyData } from "../../../../Data/UiKits/Dropdown";

const JustifyContent = () => {
  return (
    <Col lg="6">
      <Card>
        <CommonCardHeader title={JustifyContentTitle} span={JustifyContentSubTitle} />
        <CardBody className="dropdown-basic m-0">
          <div className="common-flex">
            <TextLeftDemo />
            {JustifyData &&
              JustifyData.map((item, index) => (
                <Fragment key={index}>
                  <DropdownCommon item={item} />
                </Fragment>
              ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default JustifyContent;
